var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 18.3335,
    rx: 5.5,
    ry: 5.5,
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 16.5,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 34.2942C32.8512 32.345 31.4215 30.6227 29.4326 29.3943C27.4437 28.1658 25.0069 27.5 22.5 27.5C19.9931 27.5 17.5563 28.1658 15.5674 29.3943C13.5785 30.6227 12.1488 32.345 11.5 34.2942",
    stroke: "#333333",
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.2a910ecae8eb6fd4635a243f3bc9573c.svg";
export { ForwardRef as ReactComponent };